import { Component, OnInit } from '@angular/core';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { CorspdcService } from 'app/services/corspdc.service';
import { AuthWebService } from 'app/services/authweb.service';
import { CarrierAccountService } from 'app/services/carrier-account.service';
import { parse } from 'path';
import { FilterService } from "app/shared/filter/filter.service";

@Component({
  selector: 'corspdc',
  templateUrl: './corspdc.component.html',
  styleUrls: ['./corspdc.component.scss']
})
export class CorspdcComponent implements OnInit {
  logs: any = [];
  statuses: any = [];
  flags = { flagAN: 1, flagNM: 1, flagLU: 1, flagCT: 1, flagAP: 1, flagPT: 1, flagST: 1, flagDS: 1 };
  ranks = { flagAN: 1, flagNM: 2, flagLU: 3, flagCT: 4, flagAP: 5, flagPT: 6, flagST: 7, flagDS: 8 };
  sortLabels = { flagAN: "AccountNumber", flagNM: "Name", flagLU: "LeadUser", flagCT: "CarrierType", flagAP: "ApplicationNumber", flagPT: "PermitType", flagST: "Status", flagDS: "DateSubmitted" };
  direction: boolean = false;
  criteria = "DateSubmitted";
  rankCtrl: number = 8;
  isLoading: Boolean = false;
  message: string = 'Loading  correspondence logs, please wait...';  
  keyword: any = {};
  currentPage = 1;
  isEmpty: boolean = false;
  pageSize: number = 10;
  count: number = 0;
  disabled = false;
  ShowFilter = false;
  bodyText = "";
  toCC = "";
  subject = "";
  from = "";
  careerName = "";
  appCode = "";
  permNum = "";
  dateSent = "";
  dateFrom = "";
  dateTo = "";
  filterUSelected='0';
  filterTSelected = '0';
  selectedCarrier = 0;
  carriers: any = [];
  isShown: boolean = false;
  changeClass: number = 0;
  carrierAccountNumber ="";
  carrier_account_code="";
  carrier_id: number = -1;

  filter_one = [
    {
      key: 'All',
      value:0
    },
    {
      key: 'Application',
      value: 1
    },
    {
      key: 'Permit',
      value: 2
    }
  ];

  filter_two = [
    {
      key: 'All',
      value: 0
    },
    {
      key: 'Sent',
      value: 1
    },
    {
      key: 'Received',
      value: 2
    }
    ,
    {
      key: 'Note',
      value: 3
    }
  ];

  
  constructor(private msg: ToastrService, public utility: UtilityServiceService, private corspdcService: CorspdcService, private authWebService: AuthWebService
    ,private caservice: CarrierAccountService,  private filterCarrier: FilterService) { }

  ngOnInit() {
    this.initCarrierDDL();
    this.initializeDates();
    this.setAccountNumber();
    this.initKeyword();  
    this.loadAccounts(this.currentPage, this.pageSize);
    this.utility.initTooltip();
  }



  loadAccounts = (page: number = 1, pageSize: number = 10, isDef: boolean = true) => {
    this.isLoading = true; //console.log('keyword: ', this.keyword)
    this.corspdcService.searchCorrespondenceLogs(this.keyword, page, pageSize).subscribe((result:any) => {
      this.logs = result.Items;
      this.count = result.Count;
      this.isEmpty = (this.count == 0) ? true : false;
      //this.onExcuteSort(this.rankCtrl);
      this.isLoading = false;     
      ////console.log('Logs: ', this.logs)
    }, error => {
      this.logs = [];
      this.isEmpty = true;
      //console.log('Error occured: ' + error);
      this.isLoading = false;
    });

  }

  initKeyword = () => {
    this.keyword = {
      carrier_id: this.selectedCarrier,
      filter_one: parseInt(this.filterUSelected),
      filter_two: parseInt(this.filterTSelected),
      date_from: this.dateFrom,
      date_to: this.dateTo
    };   
  }

  onReset = () => {
    this.isShown = false;
    this.filterUSelected = '0';
    this.filterTSelected = '0';
    this.selectedCarrier = 0;
    this.carrierAccountNumber ="";
    this.initializeDates();
    this.setAccountNumber();
    this.initKeyword();
    this.utility.page = 1;
    this.message = 'Loading  correspondence logs, please wait...';
    this.loadAccounts(this.utility.page, this.pageSize);
  }

  initCarrierDDL = () => {
   /*  this.corspdcService.listCarrier().subscribe(
      result => {
        this.carriers = result;
      },
      error => {
        //console.log('Error = ', error)
      }); */
  }
  setAccountNumber()  {
    this.carrier_account_code = (this.carrierAccountNumber?.replace(/\s/g, "") != "") ? this.carrierAccountNumber?.replace(/\s/g, "") : "ALL";
   // console.log("Carrier Account Number typed: " +  this.carrier_account_code);
    this.caservice.GetCarrierIDByAccountNumber(this.carrier_account_code)
    .subscribe((result:any) => {
      this.selectedCarrier = result.id;
      this.carrier_id = result.id;
    }, error => {
      console.log("Error " + error)
    }); 
    
    
   // console.log("after set number call:" + this.carrier_account_code + " the result carrier id returned: " + this.carrier_id);
  }
  onQueryChanged() {
    this.setAccountNumber();
  }
  initializeDates() {
    //if (this.dateFrom == "" || this.dateTo == "") {
      let g = new Date();
      g.setDate(g.getDate() - 90);

      let mm = (g.getMonth() + 1).toString();
      if (mm.length == 1) {
        mm = "0" + mm;
      }
      let dd = (g.getDate()).toString();
      if (dd.length == 1)
        dd = "0" + dd;

      this.dateFrom = g.getFullYear().toString() + "-" + mm + "-" + dd;

      let m = (new Date().getMonth() + 1).toString();
      if (m.length == 1)
        m = "0" + m;
      let d = (new Date().getDate()).toString();
      if (d.length == 1)
        d = "0" + d;
      this.dateTo = new Date().getFullYear() + "-" + m + "-" + d;
    //}
  }


  onSearch = () => {
    this.isShown = false;
    
    //console.log('Saved values = ', this.keyword);
    this.filterCarrier.getData().subscribe((data) => {
    this.carrierAccountNumber = data.carrierAccountNumber;
    this.filterUSelected = data.filterUSelected;
    this.filterTSelected = data.filterTSelected;
    this.dateFrom = data.dateFrom;
    this.dateTo = data.dateTo;

    this.setAccountNumber();
    
    this.initKeyword(); 
    this.utility.page = 1;
    this.message = "Searching for correspondence logs, please wait...";
    this.loadAccounts(this.utility.page, this.pageSize);

    });
    
  }

  preview = (item: any) => {    
    this.toCC = item.persons_to.toString().split(',').join('; ');
    this.bodyText = item.body_text
    this.subject = item.subject;
    this.dateSent = item.date_sent;
    this.from = item.person_from;
    this.careerName = item.carrierName;
    this.permNum = item.permit_num;
    this.appCode = item.app_id_permit_type_code;
    this.isShown = true;
    this.changeClass = item.id;    
    this.utility.initTooltip();
  }

  closeBody = () => {
    this.isShown = false;
    this.changeClass = 0;
  }

  onNextOrPrevious(page: number = 1) {
    this.message = 'Loading  permit applications, please wait...';
    this.initKeyword(); 
    this.loadAccounts(page, this.pageSize);
    this.currentPage = page;
    return page;
  }
  onChange = () => {
    this.loadAccounts(this.utility.page = 1, this.pageSize);
  }
}
